/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { NewSearchResultContent } from '../model';
// @ts-ignore
import { SearchResultContent } from '../model';
// @ts-ignore
import { SearchResultContentEmpty } from '../model';
/**
 * SearchResultContentApiSearchResultContentsCountGet - axios parameter creator
 * 
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchResultContentApiSearchResultContentsCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/search-result-contents/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchResultContentApiSearchResultContentsFullContentGet - axios parameter creator
 * 
 * @summary 
 * @param {string} service Type of service
 * @param {string} destination Destination of trip
 * @param {string} [origin] Origin of trip
 * @param {string} [hotelName] Selected hotel name (in case of hotel reserve)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchResultContentApiSearchResultContentsFullContentGetAxiosParamCreator (service: string, destination: string, origin?: string, hotelName?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'service' is not null or undefined
    assertParamExists('searchResultContentsFullContentGet', 'service', service)
    // verify required parameter 'destination' is not null or undefined
    assertParamExists('searchResultContentsFullContentGet', 'destination', destination)
    const localVarPath = `/search-result-contents/full-content`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (service !== undefined) {
        localVarQueryParameter['service'] = service;
    }

    if (origin !== undefined) {
        localVarQueryParameter['origin'] = origin;
    }

    if (destination !== undefined) {
        localVarQueryParameter['destination'] = destination;
    }

    if (hotelName !== undefined) {
        localVarQueryParameter['hotelName'] = hotelName;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchResultContentApiSearchResultContentsGet - axios parameter creator
 * 
 * @summary use /or-empty endpoint instead
 * @param {string} service Type of service
 * @param {string} destination Destination of trip
 * @param {string} [origin] Origin of trip
 * @param {string} [hotelName] Selected hotel name (in case of hotel reserve)
 * @param {*} [options] Override http request option.
 * @deprecated
 * @throws {RequiredError}
 */
async function SearchResultContentApiSearchResultContentsGetAxiosParamCreator (service: string, destination: string, origin?: string, hotelName?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'service' is not null or undefined
    assertParamExists('searchResultContentsGet', 'service', service)
    // verify required parameter 'destination' is not null or undefined
    assertParamExists('searchResultContentsGet', 'destination', destination)
    const localVarPath = `/search-result-contents`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (service !== undefined) {
        localVarQueryParameter['service'] = service;
    }

    if (origin !== undefined) {
        localVarQueryParameter['origin'] = origin;
    }

    if (destination !== undefined) {
        localVarQueryParameter['destination'] = destination;
    }

    if (hotelName !== undefined) {
        localVarQueryParameter['hotelName'] = hotelName;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchResultContentApiSearchResultContentsIdDelete - axios parameter creator
 * Delete a record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchResultContentApiSearchResultContentsIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('searchResultContentsIdDelete', 'id', id)
    const localVarPath = `/search-result-contents/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchResultContentApiSearchResultContentsIdPut - axios parameter creator
 * Update a record
 * @summary 
 * @param {string} id 
 * @param {NewSearchResultContent} newSearchResultContent 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchResultContentApiSearchResultContentsIdPutAxiosParamCreator (id: string, newSearchResultContent: NewSearchResultContent, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('searchResultContentsIdPut', 'id', id)
    // verify required parameter 'newSearchResultContent' is not null or undefined
    assertParamExists('searchResultContentsIdPut', 'newSearchResultContent', newSearchResultContent)
    const localVarPath = `/search-result-contents/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newSearchResultContent, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchResultContentApiSearchResultContentsOrEmptyGet - axios parameter creator
 * 
 * @summary 
 * @param {string} service Type of service
 * @param {string} destination Destination of trip
 * @param {string} [origin] Origin of trip
 * @param {string} [hotelName] Selected hotel name (in case of hotel reserve)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchResultContentApiSearchResultContentsOrEmptyGetAxiosParamCreator (service: string, destination: string, origin?: string, hotelName?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'service' is not null or undefined
    assertParamExists('searchResultContentsOrEmptyGet', 'service', service)
    // verify required parameter 'destination' is not null or undefined
    assertParamExists('searchResultContentsOrEmptyGet', 'destination', destination)
    const localVarPath = `/search-result-contents/or-empty`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (service !== undefined) {
        localVarQueryParameter['service'] = service;
    }

    if (origin !== undefined) {
        localVarQueryParameter['origin'] = origin;
    }

    if (destination !== undefined) {
        localVarQueryParameter['destination'] = destination;
    }

    if (hotelName !== undefined) {
        localVarQueryParameter['hotelName'] = hotelName;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchResultContentApiSearchResultContentsPost - axios parameter creator
 * Create a new record
 * @summary 
 * @param {NewSearchResultContent} newSearchResultContent 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchResultContentApiSearchResultContentsPostAxiosParamCreator (newSearchResultContent: NewSearchResultContent, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newSearchResultContent' is not null or undefined
    assertParamExists('searchResultContentsPost', 'newSearchResultContent', newSearchResultContent)
    const localVarPath = `/search-result-contents`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newSearchResultContent, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for searchResultContentsFullContentGet operation in SearchResultContentApi.
 * @export
 * @interface SearchResultContentApiSearchResultContentsFullContentGetRequest
 */
export interface SearchResultContentApiSearchResultContentsFullContentGetRequest {
    /**
     * Type of service
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsFullContentGet
     */
    readonly service: string

    /**
     * Destination of trip
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsFullContentGet
     */
    readonly destination: string

    /**
     * Origin of trip
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsFullContentGet
     */
    readonly origin?: string

    /**
     * Selected hotel name (in case of hotel reserve)
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsFullContentGet
     */
    readonly hotelName?: string
}

/**
 * Request parameters for searchResultContentsGet operation in SearchResultContentApi.
 * @export
 * @interface SearchResultContentApiSearchResultContentsGetRequest
 */
export interface SearchResultContentApiSearchResultContentsGetRequest {
    /**
     * Type of service
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsGet
     */
    readonly service: string

    /**
     * Destination of trip
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsGet
     */
    readonly destination: string

    /**
     * Origin of trip
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsGet
     */
    readonly origin?: string

    /**
     * Selected hotel name (in case of hotel reserve)
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsGet
     */
    readonly hotelName?: string
}

/**
 * Request parameters for searchResultContentsIdDelete operation in SearchResultContentApi.
 * @export
 * @interface SearchResultContentApiSearchResultContentsIdDeleteRequest
 */
export interface SearchResultContentApiSearchResultContentsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for searchResultContentsIdPut operation in SearchResultContentApi.
 * @export
 * @interface SearchResultContentApiSearchResultContentsIdPutRequest
 */
export interface SearchResultContentApiSearchResultContentsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewSearchResultContent}
     * @memberof SearchResultContentApiSearchResultContentsIdPut
     */
    readonly newSearchResultContent: NewSearchResultContent
}

/**
 * Request parameters for searchResultContentsOrEmptyGet operation in SearchResultContentApi.
 * @export
 * @interface SearchResultContentApiSearchResultContentsOrEmptyGetRequest
 */
export interface SearchResultContentApiSearchResultContentsOrEmptyGetRequest {
    /**
     * Type of service
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsOrEmptyGet
     */
    readonly service: string

    /**
     * Destination of trip
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsOrEmptyGet
     */
    readonly destination: string

    /**
     * Origin of trip
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsOrEmptyGet
     */
    readonly origin?: string

    /**
     * Selected hotel name (in case of hotel reserve)
     * @type {string}
     * @memberof SearchResultContentApiSearchResultContentsOrEmptyGet
     */
    readonly hotelName?: string
}

/**
 * Request parameters for searchResultContentsPost operation in SearchResultContentApi.
 * @export
 * @interface SearchResultContentApiSearchResultContentsPostRequest
 */
export interface SearchResultContentApiSearchResultContentsPostRequest {
    /**
     * 
     * @type {NewSearchResultContent}
     * @memberof SearchResultContentApiSearchResultContentsPost
     */
    readonly newSearchResultContent: NewSearchResultContent
}

/**
* 
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchResultContentApiSearchResultContentsCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchResultContentApiSearchResultContentsCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {SearchResultContentApiSearchResultContentsFullContentGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchResultContentApiSearchResultContentsFullContentGet(requestParameters: SearchResultContentApiSearchResultContentsFullContentGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchResultContentApiSearchResultContentsFullContentGetAxiosParamCreator(requestParameters.service, requestParameters.destination, requestParameters.origin, requestParameters.hotelName, options, configuration);
    const request: () => AxiosPromise<SearchResultContentEmpty> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary use /or-empty endpoint instead
* @param {SearchResultContentApiSearchResultContentsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @deprecated
* @throws {RequiredError}
*/
export async function SearchResultContentApiSearchResultContentsGet(requestParameters: SearchResultContentApiSearchResultContentsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchResultContentApiSearchResultContentsGetAxiosParamCreator(requestParameters.service, requestParameters.destination, requestParameters.origin, requestParameters.hotelName, options, configuration);
    const request: () => AxiosPromise<SearchResultContent> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a record
* @summary 
* @param {SearchResultContentApiSearchResultContentsIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchResultContentApiSearchResultContentsIdDelete(requestParameters: SearchResultContentApiSearchResultContentsIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchResultContentApiSearchResultContentsIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a record
* @summary 
* @param {SearchResultContentApiSearchResultContentsIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchResultContentApiSearchResultContentsIdPut(requestParameters: SearchResultContentApiSearchResultContentsIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchResultContentApiSearchResultContentsIdPutAxiosParamCreator(requestParameters.id, requestParameters.newSearchResultContent, options, configuration);
    const request: () => AxiosPromise<SearchResultContent> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {SearchResultContentApiSearchResultContentsOrEmptyGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchResultContentApiSearchResultContentsOrEmptyGet(requestParameters: SearchResultContentApiSearchResultContentsOrEmptyGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchResultContentApiSearchResultContentsOrEmptyGetAxiosParamCreator(requestParameters.service, requestParameters.destination, requestParameters.origin, requestParameters.hotelName, options, configuration);
    const request: () => AxiosPromise<SearchResultContentEmpty> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new record
* @summary 
* @param {SearchResultContentApiSearchResultContentsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchResultContentApiSearchResultContentsPost(requestParameters: SearchResultContentApiSearchResultContentsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchResultContentApiSearchResultContentsPostAxiosParamCreator(requestParameters.newSearchResultContent, options, configuration);
    const request: () => AxiosPromise<SearchResultContent> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
